export default __webpack_public_path__ + "static/media/UpTo&0.d3b35d56.png";